module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/avatar3-219f72681c25ad6c52787b93b6f5348d.png";